module.exports = __webpack_public_path__ + "img/2.1922ec17.png";